import './App.css';
import './static/css/style.css'
import AOS from 'aos';
import './static/css/aos.css';
import Home from './components/Home';
import About from './components/About';
import { useEffect } from 'react';
import Resume from './components/Resume';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Experience from './components/Experience';
import GuestBook from './components/GuestBook';
import Projects from '../src/components/Projects'
import { ThemeProvider } from './utils/ThemeContext';
import Layout from './Layout';

const MainPage = () => {
  return (
    <div>
      <Home />
      <About />
      <Resume />
    </div>
  )
}

function App() {
  useEffect(() => {
    AOS.init({ once: true });
  }, [])
  return (
    <>
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Layout />}>
              <Route index element={<MainPage />} />
              <Route path='experience' element={<Experience />} />
              <Route path='gb' element={<GuestBook />} />
              <Route path='projects' element={<Projects />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}

export default App;
